module.exports = __webpack_public_path__ + "img/1-lg.c3274704.jpg";